var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* 生年月日ログイン(申込人) */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../molecules/Block';
import Annotation from '../atoms/Annotation';
import axios from '../axios';
import RowDate from '../molecules/RowDate';
import { Row, Col } from 'react-bootstrap';
import Moment from 'moment';
import { handleBrowzerBack } from '../BrowzerBack';
import LoadingModal from '../organisms/LoadingModal';
import { Button } from 'react-bootstrap';
// 生年月日をPOSTするときのフォーマット
var momentFormat = 'YYYY-MM-DD';
var BirthLogin = function () {
    // 処理結果通知ダイアログ
    var _a = useState(), birthday_login_error_message = _a[0], setBirthDayMessage = _a[1];
    var _b = useState(Moment().subtract(30, 'years').format(momentFormat)), birthday = _b[0], setBirthDay = _b[1];
    // ローディング画面表示状態
    var _c = useState(false), is_loading = _c[0], setIsLoading = _c[1];
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
    }, []);
    var handleChangeInput = function (changed_value) {
        var setParam = '';
        if (
        // Date型
        Object.prototype.toString.call(changed_value).slice(8, -1).toLowerCase() === 'date') {
            setParam = Moment(changed_value).format(momentFormat);
        }
        else if (Object.prototype.toString.call(changed_value).slice(8, -1).toLowerCase() === 'null') {
            // null
            setParam = '';
        }
        else if (typeof changed_value === 'string') {
            // string型
            setParam = changed_value;
        }
        setBirthDay(setParam);
    };
    /**
     * ログイン
     */
    var handleBirthLoginClick = function () {
        var login = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, r_cd, r_id, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsLoading(true);
                        return [4 /*yield*/, axios.get('mypage/login/birthday_login', {
                                params: {
                                    birthday: birthday,
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        r_cd = response.data.reception_cd;
                        r_id = response.data.reception_id;
                        // 案件詳細画面へ遷移
                        // TODO sakuma 受付cd, idをURIに持たせるよう修正する
                        location.replace(process.env.MIX_MOCK_URL + "/reception/" + r_cd + "/" + r_id);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        // ログインNG
                        console.error(error_1);
                        setBirthDayMessage(error_1.response.data.message);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        login();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mt-3 mt-sm-5 birth-login-top" },
            React.createElement("div", { className: "col-11 col-sm-11 col-md-8 mx-auto" },
                React.createElement("p", null,
                    React.createElement("b", null, "\u304A\u7533\u8FBC\u307F\u3044\u305F\u3060\u304D\u307E\u3057\u305F\u30ED\u30FC\u30F3\u306E\u5BE9\u67FB\u7D50\u679C\u3092\u56DE\u7B54\u3044\u305F\u3057\u307E\u3059\u3002")))),
        React.createElement(Block, { label: "\u672C\u4EBA\u78BA\u8A8D", content: React.createElement(React.Fragment, null,
                React.createElement(Annotation, { text: "\u3054\u672C\u4EBA\u3055\u307E\u306E\u78BA\u8A8D\u3068\u3057\u3066\u3001\u751F\u5E74\u6708\u65E5\uFF08\u897F\u66A6\uFF09\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002" }),
                React.createElement("div", { className: "mt-3" }),
                React.createElement("div", null,
                    React.createElement(RowDate, { id: "birthday", value: birthday !== null && birthday !== ''
                            ? new Date(Moment(birthday).format('YYYY/MM/DD'))
                            : null, 
                        // value={new Date(birthday)}
                        label: "\u751F\u5E74\u6708\u65E5", need: true, disabled: false, handleChange: function (date) {
                            handleChangeInput(date);
                        } })),
                typeof birthday_login_error_message !== 'undefined' && (
                // ログインエラー有
                React.createElement(Row, { className: "d-flex align-items-center justify-content-center" },
                    React.createElement(Col, null),
                    React.createElement(Col, { md: 9, className: "alert-danger alert-danger-custom" }, birthday_login_error_message))),
                React.createElement("div", { className: "mt-5" }),
                React.createElement("div", { className: "text-center" },
                    React.createElement(Button, { size: "lg", onClick: handleBirthLoginClick, variant: "main-color" }, "\u5BE9\u67FB\u7D50\u679C\u306B\u9032\u3080")),
                React.createElement(LoadingModal, { show: is_loading })) })));
};
if (document.getElementById('application-person-birth-login')) {
    ReactDOM.render(React.createElement(BirthLogin, null), document.getElementById('application-person-birth-login'));
}
